<template>
  <div id="regist_input">
    <section>
      <h2>会員情報入力</h2>
      <div class="input_list">
        <input type="text" style="top: -100px; left: -100px; position: fixed;">
        <input type="password" style="top: -100px; left: -100px; position: fixed;">
        <ul>
          <li v-if="!isPrivateUser">
            <div>
              <span>{{span.corpType}}</span>
              <span class="important small_text">必須</span>
            </div>
            <select v-model.number="userForm.corpType">
              <option v-for="(type,index) in corpTypeList" :key="'corptype-' + index" v-bind:value="type.code">{{type.label}}</option>
            </select>
            <div v-if="errors.corpType" class="error_text">{{errors.corpType}}</div>
          </li>
          <li v-if="!isPrivateUser">
            <div>
              <span>{{span.corpDept}}</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="userForm.corpDept" maxlength="32"/>
            <div v-if="errors.corpDept" class="error_text">{{errors.corpDept}}</div>
          </li>
          <li class="input_text2">
            <div>
              <span>{{span.userName}}</span>
              <span class="important small_text">必須</span>
            </div>
            <div>
              <input type="text" v-model.trim="userForm.userLastName" placeholder="家具" maxlength="32"/>
              <span class="space"></span>
              <input type="text" v-model.trim="userForm.userFirstName" placeholder="太郎" maxlength="32"/>
            </div>
            <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
          </li>
          <li class="input_text2">
            <div>
              <span>{{span.userNameKana}}</span>
              <span class="important small_text">必須</span>
            </div>
            <div>
              <input type="text" v-model.trim="userForm.userLastNameKana" placeholder="カグ" maxlength="32"/>
              <span class="space"></span>
              <input type="text" v-model.trim="userForm.userFirstNameKana" placeholder="タロウ" maxlength="32"/>
            </div>
            <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
          </li>
          <li v-if="!isEdit">
            <div>
              <span>{{span.email}}</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="userForm.email" placeholder="****@domans.co.jp" maxlength="128" v-bind:disabled="!isEdit"/>
            <div class="small_p caution_msg">※仮登録したアドレスと間違いがないかご確認ください。</div>
            <div v-if="errors.email" class="error_text">{{errors.email}}</div>
          </li>
          <template v-if="!isEdit">
            <li>
              <div>
                <span>{{span.password}}</span>
                <span class="important small_text">必須</span>
              </div>
              <input type="password" v-model.trim="userForm.password" maxlength="20" autocomplete="new-password"/>
              <div class="small_p caution_msg">※半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。</div>
              <div v-if="errors.password" class="error_text">{{errors.password}}</div>
            </li>
            <li>
              <div>
                <span>{{span.confirmPassword}}</span>
                <span class="important small_text">必須</span>
              </div>
              <input type="password" v-model.trim="userForm.confirmPassword" maxlength="20" autocomplete="new-password"/>
              <div v-if="errors.confirmPassword" class="error_text">{{errors.confirmPassword}}</div>
            </li>
          </template>
          <li v-if="!isEdit">
            <div>HAKOTANをどこで知りましたか？</div>
            <select v-model.number="userForm.infosrc">
              <option value='' class="select_placeholder">選択してください</option>
              <option v-for="(type,index) in infoSrcList" :key="'infosrc-' + index" v-bind:value="type.code">{{type.label}}</option>
            </select>
          </li>
        </ul>
        <div class="notes" v-if="isRequestPayment">
          <p>※掛払い決済は審査後にご利用いただけます。</p>
          <p class="indent">審査結果は通常３営業日以内にメールでお知らせいたします。</p>
          <p class="indent">審査完了まではカード決済、銀行振込でご利用いただけます。</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'

export default {
  name: 'UserInput',
  components: {
  },
  props: {
    // leftBtnLabel: String,
    // rightBtnLabel: String,
    isEdit: Boolean,
    userForm: Object,
    isPrivateUser: {
      type: Boolean,
      default: false
    },
    isRequestPayment: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: {},
      span: {
        corpType: '業種',
        corpName: '会社名',
        corpBranchName: '支店名・営業所名',
        corpDept: '所属部署',
        userName: '氏名',
        userNameKana: '氏名（カナ）',
        email: 'メールアドレス',
        password: 'パスワード',
        confirmPassword: 'パスワード（確認用）',
        tel: '電話番号',
        fax: 'FAX',
        postcd: '郵便番号',
        state: '住所',
        street: '以下住所'
      },
      isPasswordUpdate: false
    }
  },
  computed: {
    corpTypeList: function () {
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
    },
    infoSrcList: function () {
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
    }
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validatedPassword()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }

      return true
    },
    validateRequire: function () {
      if (!this.isPrivateUser) {
        if (this.userForm.corpType === undefined || this.userForm.corpType === '') {
          this.errors['corpType'] = this.span.corpType + 'は必須項目です。'
        }
        if (!this.userForm.corpDept) {
          this.errors['corpDept'] = this.span.corpDept + 'は必須項目です。'
        }
      }
      if (!this.userForm.userLastName || !this.userForm.userFirstName) {
        this.errors['userName'] = this.span.userName + 'は必須項目です。'
      }
      if (!this.userForm.userLastNameKana || !this.userForm.userFirstNameKana) {
        this.errors['userNameKana'] = this.span.userNameKana + 'は必須項目です。'
      }
      if (!this.isEdit) {
        if (!this.userForm.email) {
          this.errors['email'] = this.span.email + 'は必須項目です。'
        }
        if (!this.userForm.password) {
          this.errors['password'] = this.span.password + 'は必須項目です。'
        }
        if (!this.userForm.confirmPassword) {
          this.errors['confirmPassword'] = this.span.confirmPassword + 'は必須項目です。'
        }
      }
    },
    validateFormat: function () {
      if (!Check.isKana(this.userForm.userLastNameKana) || !Check.isKana(this.userForm.userFirstNameKana)) {
        this.errors['userNameKana'] = this.span.userNameKana + 'はカタカナで入力してください。'
      }
      if (!this.isEdit) {
        if (!Check.isMail(this.userForm.email)) {
          this.errors['email'] = 'メールアドレスの形式ではありません。'
        }
      }
      if (!this.isEdit) {
        if (!Check.isPassword(this.userForm.password)) {
          this.errors['password'] = this.span.password + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
        }
        if (!Check.isPassword(this.userForm.confirmPassword)) {
          this.errors['confirmPassword'] = this.span.confirmPassword + 'は半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。'
        }
      }
    },
    validatedPassword: function () {
      if (this.userForm.password !== this.userForm.confirmPassword) {
        this.errors['confirmPassword'] = this.span.confirmPassword + 'が一致しません'
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/user/DcUserInfo.vue